import { Tabs, TabList, TabPanels, TabPanel, Tab } from "@chakra-ui/react";
import React from "react";
import { useParams, Link as ReactRouterLink } from "react-router-dom";
import {
  PageHeadingContainer,
  PageContainer,
} from "../components/atoms/Containers";
import { PageHeading } from "../components/atoms/Headings";
import { buildAccountSettingsLink } from "../routers/routePaths";
import { useCurrentAccountStore } from "../store/currentAccountStore";
import { AccountGeneralSettings } from "./accountSettings/AccountGeneralSettings";
import { AccountMembersSettings } from "./accountSettings/AccountMembersSettings";
import { AccountOtherSettings } from "./accountSettings/AccountOtherSettings";
import { AccountReportSettings } from "./accountSettings/AccountReportSettings";
import { AccountTaxSettings } from "./accountSettings/AccountTaxSettings";
import { AccountSubscriptionSettings } from "./accountSettings/subscription/AccountSubscriptionSettings";

export enum AccountSettingsPanel {
  Tax = "tax",
  General = "general",
  Report = "report",
  Subscription = "subscription",
  Members = "members",
  Other = "other",
}

const PANEL_TABS: AccountSettingsPanel[] = [
  AccountSettingsPanel.Tax,
  AccountSettingsPanel.General,
  AccountSettingsPanel.Report,
  AccountSettingsPanel.Subscription,
  AccountSettingsPanel.Members,
  AccountSettingsPanel.Other,
];

export function AccountSettings() {
  const accountId = useCurrentAccountStore(({ accountId }) => accountId);
  const { panel } = useParams<{ panel?: AccountSettingsPanel }>();

  const matchingIndex = PANEL_TABS.indexOf(panel || AccountSettingsPanel.Tax);
  const tabIndex = matchingIndex > -1 ? matchingIndex : 0;

  return (
    <PageContainer>
      <PageHeadingContainer>
        <PageHeading>Settings</PageHeading>
      </PageHeadingContainer>
      <Tabs isLazy index={tabIndex}>
        <TabList
          width="100%"
          sx={{
            scrollbarWidth: "none",
            "::-webkit-scrollbar": {
              display: "none",
            },
          }}
        >
          <Tab
            as={ReactRouterLink}
            to={buildAccountSettingsLink({
              accountId,
              panel: AccountSettingsPanel.Tax,
            })}
          >
            Tax
          </Tab>

          <Tab
            as={ReactRouterLink}
            to={buildAccountSettingsLink({
              accountId,
              panel: AccountSettingsPanel.General,
            })}
          >
            General
          </Tab>

          <Tab
            as={ReactRouterLink}
            to={buildAccountSettingsLink({
              accountId,
              panel: AccountSettingsPanel.Report,
            })}
          >
            Reports
          </Tab>

          <Tab
            as={ReactRouterLink}
            to={buildAccountSettingsLink({
              accountId,
              panel: AccountSettingsPanel.Subscription,
            })}
          >
            Subscription
          </Tab>

          <Tab
            as={ReactRouterLink}
            to={buildAccountSettingsLink({
              accountId,
              panel: AccountSettingsPanel.Members,
            })}
          >
            Members
          </Tab>

          <Tab
            as={ReactRouterLink}
            to={buildAccountSettingsLink({
              accountId,
              panel: AccountSettingsPanel.Other,
            })}
          >
            Other
          </Tab>
        </TabList>

        <TabPanels w="full" overflowY="auto">
          <TabPanel px={0} pt="2rem">
            <AccountTaxSettings />
          </TabPanel>

          <TabPanel px={0} pt="2rem">
            <AccountGeneralSettings />
          </TabPanel>

          <TabPanel px={0} pt="2rem">
            <AccountReportSettings />
          </TabPanel>

          <TabPanel px={0} pt="2rem">
            <AccountSubscriptionSettings />
          </TabPanel>

          <TabPanel px={0} pt="2rem">
            <AccountMembersSettings />
          </TabPanel>

          <TabPanel px={0} pt="2rem">
            <AccountOtherSettings />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </PageContainer>
  );
}
